module.exports = __webpack_public_path__ + "img/ico_package.9e6988f2.png";